import type { LiveChallengeKind } from './types.js';

export interface LiveChallengeDefinition {
  id: LiveChallengeKind;
  name: string;
  description: string;
  completion: string;
}

export const LIVE_CHALLENGES: readonly LiveChallengeDefinition[] = [
  {
    id: 'clean-sector',
    name: 'CLEAN SECTOR',
    description: 'Reach the next sector without contact.',
    completion: 'SECTOR SECURED',
  },
  {
    id: 'pass-rival',
    name: 'HUNT THE PACK',
    description: 'Complete one clean overtake.',
    completion: 'TARGET PASSED',
  },
  {
    id: 'route-choice',
    name: 'BREAK THE LINE',
    description: 'Complete an alternate route.',
    completion: 'ROUTE CLEARED',
  },
  {
    id: 'speed-trap',
    name: 'SPEED TRAP',
    description: 'Hit the target speed before time expires.',
    completion: 'TRAP BEATEN',
  },
  {
    id: 'style-chain',
    name: 'KEEP IT ALIVE',
    description: 'Build the requested style chain.',
    completion: 'CHAIN LOCKED',
  },
] as const;

const DEFINITIONS = new Map(LIVE_CHALLENGES.map((challenge) => [challenge.id, challenge]));

export function liveChallengeDefinition(kind: LiveChallengeKind | null | undefined): LiveChallengeDefinition | null {
  return kind ? DEFINITIONS.get(kind) ?? null : null;
}

/** Stable selection keeps offline resume and server replay deterministic. */
export function chooseLiveChallenge(
  seed: string,
  options: { rivals: boolean; routes: boolean },
): LiveChallengeKind {
  const candidates: LiveChallengeKind[] = ['clean-sector', 'speed-trap', 'style-chain'];
  if (options.rivals) candidates.push('pass-rival');
  if (options.routes) candidates.push('route-choice');
  return candidates[stableHash(seed) % candidates.length]!;
}

function stableHash(value: string): number {
  let result = 2_166_136_261;
  for (let index = 0; index < value.length; index += 1) {
    result ^= value.charCodeAt(index);
    result = Math.imul(result, 16_777_619);
  }
  return result >>> 0;
}
